import plotly_grayscale from './plotly-grayscale.svg';
import django_grayscale from './django-square-1.svg';
// the rest of badges are handled by font-awesome

const images = {
  plotly: plotly_grayscale,
  django: django_grayscale
}

export default images;